import styled from 'styled-components';
import {
  ApButtonDanger,
  ApButtonSecondary,
  ApIcon,
  colors,
} from '@alixpartners/ui-components';
import { NavLink } from 'react-router-dom';

export const MainContentWrapper = styled.div`
  display: flex;
  height: 100%;
  overflow: auto;
`;

export const LeftSidebarContainer = styled.div`
  height: calc(100vh - 96px);
  width: 320px;
  overflow: auto;
  background: ${colors.white};
  box-shadow: 1px 2px 4px ${colors.grey3};
  display: flex;
  flex-direction: column;
  padding-top: 12px;
`;

export const FileDataWrapper = styled.div`
  width: calc(100% - 320px);
  padding: 32px;
  display: flex;
  flex-direction: column;
`;

export const SideBarItem = styled(NavLink)<{ active?: boolean }>`
  height: 64px;
  width: 320px;
  color: ${(props) => (props.active ? colors.white : colors.grey8)};
  background-color: ${(props) =>
    props.active ? colors.green1 : colors.transparent};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 32px;
  text-decoration: none;
`;

export const SideBarItemText = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.3px;
`;

export const SideBarItemIcon = styled.div``;

export const Title = styled.div`
  font-weight: 500;
  font-size: 19px;
  line-height: 27px;
  padding: 0 32px;
  margin: 16px 0 8px;
`;

export const Description = styled.div`
  padding: 16px 32px 0;
  font-size: 13px;
  letter-spacing: 0.3px;
  line-height: 19px;
  font-weight: 400;
  color: ${colors.grey5};
`;

export const FileRowsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ErrorsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid ${colors.grey3};
`;

export const DeleteAllButton = styled(ApButtonDanger)`
  margin: 16px;
`;

export const DeleteAllDataContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const WarningIcon = styled(ApIcon)`
  color: ${colors.red1};
  margin: 32px 0;
`;

export const DeleteAllText = styled.div`
  font-size: 16px;
  color: ${colors.grey7};
  letter-spacing: 0.3px;
  font-weight: 400;
`;

export const DeleteAllTextWarning = styled(DeleteAllText)`
  font-weight: 700;
  margin: 12px 0;
`;

export const LinksToSpendWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: 48px;
`;

export const LinksToSpendContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 5px solid ${colors.green1};
  width: 516px;
  padding: 24px;
  background-color: ${colors.white};
`;

export const LinksToSpendDescription = styled.div`
  color: ${colors.green2};
  font-size: 19px;
  font-weight: 700;
`;

export const LinksToSpendActions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 8px;
`;

export const ClassifySpendContainer = styled.div`
  width: 162px;
  margin-bottom: 24px;
`;

export const DownloadButton = styled(ApButtonSecondary)`
  margin: 8px 32px;
`;

export const DownloadDialogContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DownloadText = styled.div`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.3px;
  color: ${colors.grey7};
`;

export const DownloadPeriodsWrapper = styled.div`
  display: flex;
`;

export const PeriodContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 24px;
`;
export const PeriodLabel = styled.div`
  display: flex;
  margin-bottom: 8px;
  font-size: 13px;
  color: ${colors.grey5};
`;

export const DownloadRows = styled.div`
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.3px;
  color: ${colors.grey5};
  margin-top: 8px;
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
  button {
    margin-right: 24px;
  }
`;

export const AutoClassificationActionContainer = styled.div`
  flex-direction: column;
`;

export const AutoClassificationText = styled.div`
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.3px;
  margin-bottom: 24px;
`;
